export default function DefaultButton({ onClick }) {
    return(
        <button className="btn btn-light" onClick={onClick} id="default-bound">Default</button>
    )
}